<template>
	<div class="text_privacy">
		<p style="text-align: center;"><span style="font-size: 18pt;"><strong>Privacy Policy</strong></span></p>
		<h3><span style="font-size: 12pt;"><strong>INTRODUCTION</strong></span></h3>
		<p><span style="font-size: 12pt;">We recognize that persons who access and/or use (&ldquo;you&rdquo; or
				&ldquo;Users&rdquo;) our games, whether played on our website, on mobile devices, PCs or on other
				platforms, (&ldquo;LUCKYYX GAME&rdquo;) and other related services, including but not limited to
				customer supporting, marketing and advertising, (collectively, the &ldquo;Services&rdquo;) value their
				privacy.</span></p>
		<p><span style="font-size: 12pt;">This Privacy Policy provides important information regarding:</span></p>
		<ol>
			<li><span style="font-size: 12pt;">i) the data collected from you and the ways we collect your data,</span>
			</li>
			<li><span style="font-size: 12pt;">ii) the reasons why we collect your data,</span></li>
		</ol>
		<p><span style="font-size: 12pt;">iii) to whom we disclose your data, and</span></p>
		<ol>
			<li><span style="font-size: 12pt;">iv) the options you have about your personal data.</span></li>
		</ol>
		<p><span style="font-size: 12pt;">Unless stated otherwise, this Privacy Policy applies to the Services and all
				data that we collect from you. We therefore provide this Privacy Policy to help you make an informed
				choice about whether to use or continue using our Services. We may periodically update this Privacy
				Policy by posting a new version on our website. Your continued use of the Services after the effective
				date will be subject to the new version of Privacy Policy.</span></p>
		<p><span style="font-size: 12pt;">This Privacy Policy is incorporated into, forms part of and is subject to the
				Terms of Service. Your use of the Services and any personal information you provide on the Site is
				subject to the terms of this Privacy Policy and the Agreement.</span></p>
		<p><span style="font-size: 12pt;">Any terms not defined herein but defined in the Terms of Service shall have
				the meaning ascribed thereto in the Terms of Service.</span></p>
		<p>&nbsp;</p>
		<ol>
			<li><span style="font-size: 12pt;"><strong> THE DATA&nbsp;COLLECTED&nbsp;FROM YOU&nbsp;AND THE
						WAYS&nbsp;WE&nbsp;COLLECT YOUR DATA</strong></span></li>
		</ol>
		<h4><span style="font-size: 12pt;"><strong>1. Data provided by you</strong></span></h4>
		<p><span style="font-size: 12pt;">To use the Services, you may directly provide certain personally identifiable
				information to us, such as:</span></p>
		<ul>
			<li><span style="font-size: 12pt;">Contact information (e.g. your name, personal identification number,
					postal or e-mail address, telephone numbers)</span></li>
			<li><span style="font-size: 12pt;">Registered user name and password</span></li>
			<li><span style="font-size: 12pt;">Character Information (e.g. Account ID, character name, profile picture.
					Please be reminded that such information may be disclosed to other users in connection with the use
					of the Services and may also be made available to your connections or the public on third party
					services)</span></li>
			<li><span style="font-size: 12pt;">Personal content preferences</span></li>
			<li><span style="font-size: 12pt;">Profile information (e.g. profile photo)</span></li>
			<li><span style="font-size: 12pt;">Messages to the Services (e.g. chat logs, your support tickets)</span>
			</li>
			<li><span style="font-size: 12pt;">Billing and financial information (Please be reminded that the use of any
					merchant service provider and/or third party platforms for the payment of the Admission Fee is
					subject to the privacy policy of the relevant merchant service providers and/or third party
					platforms)</span></li>
			<li><span style="font-size: 12pt;">Other data that you voluntarily provide (e.g. data to identify a lost
					account)</span></li>
		</ul>
		<h4><span style="font-size: 12pt;"><strong>2. Data collected automatically</strong></span></h4>
		<p><span style="font-size: 12pt;">When you access our Website or use the Services, we may use cookies and/or
				other similar technologies. Cookies are small text files stored by browser(s) on your desktop computer
				or mobile device. Most web browsers automatically accept cookies, but you can usually modify browser
				setting to decline cookies. If you choose to decline cookies, you may not be able to access certain
				Services and may experience technical problems receiving current information from the cookie-disabled
				services.&nbsp;The use of cookies and/or other similar technologies is to identify your browsers and to
				collect data from your device such as:</span></p>
		<ul>
			<li><span style="font-size: 12pt;">Data about your Account</span></li>
			<li><span style="font-size: 12pt;">Internet Protocol (IP) address, web request, domain name, URLs,
					referring/exit pages, platform type and mobile device identifiers (e.g. your device ID, advertising
					ID, MAC address, IMEI)</span></li>
			<li><span style="font-size: 12pt;">Data about your device (e.g. device name, operating system, browser type
					and language)</span></li>
			<li><span style="font-size: 12pt;">Data we collect with cookies and similar technologies</span></li>
			<li><span style="font-size: 12pt;">Monitoring of aggregate metrics (e.g. total number of visitors, pages
					viewed, usage of the Services)</span></li>
			<li><span style="font-size: 12pt;">General location data</span></li>
			<li><span style="font-size: 12pt;">Precise geo-location data (i.e. GPS)</span></li>
			<li><span style="font-size: 12pt;">Data about your use of the Services (e.g. number of clicks, landing
					pages, pages viewed and order of those pages, the amount of time spent on particular pages, the date
					and time of your request, your game play and activity, your game progress, your interactions with
					other players inside the Services)</span></li>
			<li><span style="font-size: 12pt;">Other pieces of information in connection with your various activities
					within or through the Services or otherwise that are sent by your browser, device or computer system
					when you access the Services, which are automatically tracked and recorded by our servers</span>
			</li>
		</ul>
		<h4><span style="font-size: 12pt;"><strong>3. Data collected from our partners</strong></span></h4>
		<p><span style="font-size: 12pt;">When you access the Services through any third party services such as social
				networking sites (e.g. Facebook, WeChat, Google) or from any mobile devices, you allow us access to
				certain information stored on these third party services or mobile devices such as:</span></p>
		<ul>
			<li><span style="font-size: 12pt;">Demographic data (e.g. determination of your IP address)</span></li>
			<li><span style="font-size: 12pt;">Data to fight against fraud (e.g. refund abuse in games or click fraud in
					advertising)</span></li>
			<li><span style="font-size: 12pt;">Data from platforms that the games run on (e.g. verification of
					&nbsp;payment)</span></li>
			<li><span style="font-size: 12pt;">Data associated with your device (e.g. device type, technological
					information, telephone number, country, contacts)</span></li>
			<li><span style="font-size: 12pt;">Data to do advertising, marketing and analysis</span></li>
		</ul>
		<p>&nbsp;</p>
		<ol>
			<li><span style="font-size: 12pt;"><strong> II. THE REASON WHY WE COLLECT YOUR DATA</strong></span></li>
		</ol>
		<h4><span style="font-size: 12pt;"><strong>1. To provide the Services</strong></span></h4>
		<p><span style="font-size: 12pt;">To provider the Services, we process data necessary to</span></p>
		<ul>
			<li><span style="font-size: 12pt;">Create Accounts</span></li>
			<li><span style="font-size: 12pt;">Allow you to play LUCKYYX GAME and use the Services</span></li>
			<li><span style="font-size: 12pt;">Operate the Services</span></li>
			<li><span style="font-size: 12pt;">Verify and confirm payments</span></li>
			<li><span style="font-size: 12pt;"> Provide and deliver products and services that you request</span></li>
			<li><span style="font-size: 12pt;">Send service-related communications to you</span></li>
		</ul>
		<h4><span style="font-size: 12pt;"><strong>2. To improve and optimize the Services</strong></span></h4>
		<p><span style="font-size: 12pt;">To provide better Services to you, we have a legitimate interest to collect
				and process necessary data to</span></p>
		<ul>
			<li><span style="font-size: 12pt;">Update and develop the Services</span></li>
			<li><span style="font-size: 12pt;">Manage and update your Account</span></li>
			<li><span style="font-size: 12pt;">Develop and improve your experience</span></li>
			<li><span style="font-size: 12pt;">Manage the relationship with you</span></li>
			<li><span style="font-size: 12pt;">Provide social features to you</span></li>
			<li><span style="font-size: 12pt;">Customize your service experience</span></li>
			<li><span style="font-size: 12pt;">Respond to your comments and questions and provide support to you</span>
			</li>
			<li><span style="font-size: 12pt;">Provide offers in the Services as well as in other websites and
					services</span></li>
			<li><span style="font-size: 12pt;">Send related information (e.g. updates, security alerts, support
					messages) to you</span></li>
			<li><span style="font-size: 12pt;">Enable you to communicate with other users</span></li>
		</ul>
		<h4><span style="font-size: 12pt;"><strong>3. To carry out activities related to advertisements and
					marketing</strong></span></h4>
		<p><span style="font-size: 12pt;">To send you personalized advertising and marketing materials, we may use the
				information collected from you such as ad identifiers, age, country, region, gender, language, games
				played by you, information related to the interaction of you with the Services and with other users, and
				so forth.</span></p>
		<p><span style="font-size: 12pt;">We may also use various third party advertising and marketing partners to
				assist us on our behalf and may share information collected from you with such third parties for this
				purpose.</span></p>
		<p><span style="font-size: 12pt;">Hence, we have a legitimate interest to process necessary data to</span></p>
		<ul>
			<li><span style="font-size: 12pt;">Track the content you access in connection with the Services and your
					online behavior</span></li>
			<li><span style="font-size: 12pt;">Deliver, target and improve our advertising and marketing
					materials</span></li>
			<li><span style="font-size: 12pt;">Pass the information collected from you to third party advertising and
					marketing partners</span></li>
		</ul>
		<p><span style="font-size: 12pt;">By accepting this Privacy Policy and downloading or continuing to use the
				Services, you consent to us and our advertising and marketing partners collecting and using information
				about you to personalize advertising and marketing materials and to improve your experience unless you
				opt out of receiving this service.</span></p>
		<p><span style="font-size: 12pt;">We encourage you to review the privacy policies of our third party advertising
				and marketing partners so that you can understand how these third parties collect, use and share your
				information. We are not responsible for the privacy policies of any third party whether accessed through
				the Services or otherwise.&nbsp;&nbsp;</span></p>
		<p><span style="font-size: 12pt;">For information on how to opt-out from receiving personalized advertising and
				marketing materials, see section 'The options you have about your personal data&rdquo; below.</span></p>
		<h4><span style="font-size: 12pt;"><strong>4. To secure the Services</strong></span></h4>
		<p><span style="font-size: 12pt;">Ensuring the security in the course of performing the Services is a top
				priority for us. We take appropriate security and technical measures to protect your information from
				unauthorized access, loss and misuse. To achieve this purpose, we also request our suppliers who process
				personal information on our behalf to take appropriate security measures.</span></p>
		<p><span style="font-size: 12pt;">In order to keep the Service and its social features safe and fair, to fight
				fraud and to ensure acceptable use otherwise, we have a legitimate interest to process necessary data
				to</span></p>
		<ul>
			<li><span style="font-size: 12pt;">Analyze and monitor use of the Services and its social features</span>
			</li>
			<li><span style="font-size: 12pt;">Moderate and monitor chats</span></li>
			<li><span style="font-size: 12pt;">Prevent cheating, crime or fraud</span></li>
			<li><span style="font-size: 12pt;">Take action against fraudulent or misbehaving users&nbsp;</span></li>
			<li><span style="font-size: 12pt;">Pass your information to agencies or organizations in charge of crime and
					fraud prevention and repression</span></li>
		</ul>
		<p><span style="font-size: 12pt;">Despite our efforts, we cannot guarantee the absolute security of your
				personal data, nor can we ensure the security of any of the communication facilities provided by us. We
				recommend that you exercise caution when disclosing any information through the Services. In particular,
				please note that any personally identifiable information or personally sensitive data that you
				communicate or disclose to any user in connection with the Services may be collected and used by others.
				As such, you should take care of the information shared online. Please also be reminded that any
				questions answers, comments, submissions that you post in the forum will be publicly available.</span>
		</p>
		<h4><span style="font-size: 12pt;"><strong>5. To analyze, research and test</strong></span></h4>
		<p><span style="font-size: 12pt;">In all of the above cases and purposes, we may use analytic tools, which may
				include third party&rsquo;s analytic tools, to carry out research, surveys and analysis, to create
				reports for use, to track potential problems of the Services or to test out new game features and
				content.</span></p>
		<h4><span style="font-size: 12pt;"><strong>6. To obtain your consent</strong></span></h4>
		<p><span style="font-size: 12pt;">With your consent, we may process personal data for additional
				purposes.</span></p>
		<p>&nbsp;</p>
		<ol>
			<li><span style="font-size: 12pt;"><strong>III. TO WHOM WE DISCLOSE YOUR DATA</strong></span></li>
			<li><span style="font-size: 12pt;"><strong>1. Our personnel, related or affiliated companies</strong></span>
			</li>
		</ol>
		<p><span style="font-size: 12pt;">We may provide your personally identifiable information and
				non-personally-identifiable information to our personnel, our related or affiliated companies for our
				legitimate business purposes. We may also provide your personally identifiable information and
				non-personally-identifiable information to other businesses or persons for the purpose of processing
				such information or otherwise assist us in performing any services on our behalf including in any
				advertising and marketing activities. We require that these parties agree to process such information in
				compliance with our Privacy Policy contained herein, and we will use reasonable efforts to limit their
				use of such information and to use other appropriate confidentiality and security measures.</span></p>
		<ol start="2">
			<li><span style="font-size: 12pt;"><strong>2. Other users</strong></span></li>
		</ol>
		<p><span style="font-size: 12pt;">As social features are a core element of our games, other users may see your
				profile data, in-game activities and read the messages you have posted.</span></p>
		<p><span style="font-size: 12pt;">Any user who receives any information including personally identifiable
				information, from another user shall not disclose or use such information, save where expressly
				permitted by that user or save where such information has ceased to be of a confidential nature. In any
				event, we shall not be liable for any unauthorized disclosure or use by another user or other person of
				any content.</span></p>
		<ol start="3">
			<li><span style="font-size: 12pt;"><strong> 3. Partners working for us</strong></span></li>
		</ol>
		<p><span style="font-size: 12pt;">To strengthen functions of our Services and your experience of use, some of
				our Services maybe provided by partners in charge of advertising, payment, analysis, marketing, social
				media partners, personalized services, and/or personalized push notifications and recommendations. To
				the extent of law and for the purposes of advertising, payment, statistic analysis, marketing,
				personalized services and/or personalized push notifications and recommendations, we may share with
				these partners your data, including but not limited to your device information such as its device brand,
				device manufacturer, device platform and device ID number, your applications list, internet information
				and GPS location information, that you have consented to our collection. In addition, these partners may
				also access your data when you use their services and operate under their own privacy policies. We
				encourage you to check their privacy policies to learn more about their data processing practices. You
				may click&nbsp;<u>here</u>&nbsp;to know the details of the data disclosing.</span></p>
		<h4><span style="font-size: 12pt;"><strong>4. Other companies and public authorities</strong></span></h4>
		<p><span style="font-size: 12pt;">We may release personally identifiable information and/or
				non-personally-identifiable information to, exchange such information with companies and organizations
				or provide such information to public authorities if required to do so by law, or in the good faith
				belief that such action is necessary to comply with all and any applicable laws, or where it is pursuant
				to or we are required to respond to a governmental, regulatory, administrative or court order or
				directive, a subpoena or a search warrant, or to combat fraud and illegal activity.</span></p>
		<p><span style="font-size: 12pt;">We also reserve the right to disclose personally identifiable information
				and/or non-personally-identifiable information that we believe, in good faith, is appropriate or
				necessary to enforce the Agreement, take precautions against liability, to investigate and defend
				against any third-party claims or allegations, to assist government authorities and enforcement
				agencies, to protect the security or integrity of the Services, and to protect the rights, property, or
				personal safety of ourselves, our users or others.</span></p>
		<p>&nbsp;</p>
		<ol>
			<li><span style="font-size: 12pt;"><strong> IV. THE OPTIONS YOU HAVE ABOUT YOUR PERSONAL
						DATA</strong></span></li>
		</ol>
		<h4><span style="font-size: 12pt;"><strong>1. Opt out of advertising and/or marketing materials</strong></span>
		</h4>
		<p><span style="font-size: 12pt;">You may opt out of receiving advertising and/or marketing communications by
				following the instructions in such communications or by using options provided in the settings in the
				game or on your devices.</span></p>
		<h4><span style="font-size: 12pt;"><strong>2. Access and correct the personal data we hold about
					you</strong></span></h4>
		<p><span style="font-size: 12pt;">You have the right to access and correct your personal data.</span></p>
		<h4><span style="font-size: 12pt;"><strong>3. Other rights</strong></span></h4>
		<p><span style="font-size: 12pt;">You also have the right to have your personal data deleted, object how we use
				or share your personal data, and restrict how we use or share your personal data. You can always
				withdraw your consent.</span></p>
		<p><span style="font-size: 12pt;">If you have questions about data protection, or any requests for resolving
				issues with your personal data, we encourage you to primarily contact us through the game so we can
				reply to you more quickly. We will respond to all requests within a reasonable time frame.</span></p>
		<p>&nbsp;</p>
		<ol>
			<li><span style="font-size: 12pt;"><strong>V. INTERNATIONAL DATA TRANSFERS</strong></span></li>
		</ol>
		<p><span style="font-size: 12pt;">By accepting this Privacy Policy, Users understand and agree that your data
				may be collected, stored, used in any country and/or transferred to any country in the world. Because
				different countries may have different data protection laws than Users&rsquo; own country, we will try
				to ensure that adequate safeguards are in place to protect Users&rsquo; data.</span></p>
		<p>&nbsp;</p>
		<ol>
			<li><span style="font-size: 12pt;"><strong> VI. SPECIAL NOTE TO INTERNATIONAL USERS</strong></span></li>
		</ol>
		<p><span style="font-size: 12pt;">The use of the Website and Services and this Agreement is governed by and
				shall be construed and enforced under the laws of Singapore, without applying any conflicts of law
				principles that would require application of the law of any other jurisdiction. You agree to submit to
				the personal non-exclusive jurisdiction in Singapore and any other court of competent jurisdiction
				chosen by us.</span></p>
		<p><span style="font-size: 12pt;">In the event of any dispute arising out of or in connection with this
				Agreement, including any question regarding its existence, validity or termination, (a
				&ldquo;Dispute&rdquo;), we strongly encourage that a resolution first be sought through our Customer
				Support service.</span></p>
		<p><span style="font-size: 12pt;">You agree that in the event that a resolution is not obtained through our
				Customer Support service, such Dispute shall be referred by you and may be referred by us to and finally
				resolved by arbitration in Singapore in accordance with the Arbitration Rules of the Singapore
				International Arbitration Centre ("SIAC Rules") for the time being in force, which rules are deemed to
				be incorporated by reference in this clause. The Tribunal shall consist of three (3) arbitrators, with
				you appointing one (1) arbitrator and us appointing one (1) arbitrator and the third arbitrator to be
				selected by the two (2) arbitrators so appointed. The language of the arbitration shall be
				English.</span></p>
		<p><span style="font-size: 12pt;">Notwithstanding any of the foregoing, you agree that we are entitled to submit
				such Dispute for resolution through any other dispute resolution mechanism including the courts of any
				jurisdiction and we shall further be entitled to seek any injunctive or other equitable relief in the
				event of any breach or anticipatory breach by you, without any obligations of providing any bond or
				surety or proof of damages.</span></p>
		<p><span style="font-size: 12pt;">You irrevocably waive all rights to seek any injunctive or other equitable
				relief or to enjoin or restrain the operation or exploitation of the Services or any part thereof. You
				further irrevocably waive all rights to a class or representative action or as a named or unnamed member
				in a class, consolidated, representative or private attorney general action.</span></p>
		<p>&nbsp;</p>
		<ol>
			<li><span style="font-size: 12pt;"><strong>VII. OUR POLICIES CONCERNING CHILDREN</strong></span></li>
		</ol>
		<p><span style="font-size: 12pt;">The Services are not intended to be accessed by persons under the age of 13,
				nor do we knowingly collect or solicit personal data therefrom. In the event that we learn that we have
				inadvertently gathered personally identifiable information from persons under the ages set out below, we
				will take commercially reasonable measures to ensure that such information is removed from our
				records.</span></p>
		<p>&nbsp;</p>
		<ol>
			<li><span style="font-size: 12pt;"><strong> VIII. DATA SECURITY</strong></span></li>
		</ol>
		<p><span style="font-size: 12pt;">We use commercially reasonable physical, managerial, and technical safeguards
				to preserve the integrity and security of your personal information. We cannot, however, ensure or
				warrant the security of any information you disclose on, through or within the Services and you do so
				entirely at your own risk. Please note that we cannot guarantee that such information may not be
				accessed, disclosed, altered, or destroyed by breach of any of our physical, technical, or managerial
				safeguards.</span></p>
		<p><span style="font-size: 12pt;">If we learn of a security systems breach, we may attempt to notify you
				electronically so that you can take appropriate protective steps. We may post a notice on the Website if
				a security breach occurs.</span></p>
		<p><span style="font-size: 12pt;">If you create an Account with the LUCKYYX GAME&nbsp;Platform, you will be
				required to select a password that can be changed at any time after you first log into the Account by
				using your current password. You are solely responsible for maintaining the confidentiality of your
				password and are fully responsible for all activities that occur under your Account and password or your
				account with any other third party service. Users agree to (i) notify us immediately if you are aware or
				reasonably suspect of any unauthorized use of your Account or password or of any unauthorized access of
				the Services through your Account, and (ii) ensure that you exit from your Account at the end of each
				session.</span></p>
		<p>&nbsp;</p>
		<ol>
			<li><span style="font-size: 12pt;"><strong> IX. MERGER, ACQUISITION, SALE OR INSOLVENCY</strong></span></li>
			<li><span style="font-size: 12pt;">1. In the event that we are acquired by or merged with another entity, we
					reserve the right, in any of these circumstances, to transfer the information or assign our rights
					to the information that we have collected from our Users as part of such merger, acquisition, sale,
					or other change of control.</span></li>
			<li><span style="font-size: 12pt;">2. In the event of our insolvency, reorganization, receivership,
					winding-up or assignment for the benefit of creditors, or the application of laws or equitable
					principles affecting creditors' rights generally, we may not be able to control how your personal
					information is treated, transferred, or used.</span></li>
		</ol>
		<p>&nbsp;</p>
		<ol>
			<li><span style="font-size: 12pt;">X. Notes on Facebook Information Collection and Removal</span></li>
			<li><span style="font-size: 12pt;">1. When a user logs into the application with a Facebook authorization,
					we will collect the user's email address and personal public information, which is mainly used to
					create an account and provide personalized services</span></li>
			<li><span style="font-size: 12pt;">2. When users delete the game application or remove the application
					authorization in Facebook settings and privacy, we will delete all the user's information.</span>
			</li>
			<li><span style="font-size: 12pt;">3. If you no longer use Facebook authorization to login, you can contact
					us to delete your Facebook authorization data and content information, which cannot be restored once
					deleted.</span></li>
			<li><span style="font-size: 12pt;"><strong>XI</strong><strong>.</strong><strong>Notes on account
						deletion</strong></span></li>
		</ol>
		<p>&nbsp;</p>
		<ol>
			<li><span style="font-size: 12pt;">1. Users delete their accounts according to their own wishes, deletion of
					the account is deemed to agree to our "Account Deletion Agreement", you agree to reach this
					agreement with our company, and voluntarily accept all the terms of the agreement.</span></li>
			<li><span style="font-size: 12pt;">2. Account deletion is a non-recoverable operation, after deleting the
					account, you will not be able to use the account to log in to all of our products and services, and
					you will not be able to retrieve any of the content and information that you have added or bound
					through the account, even if you choose the same mailbox to register again and use the products and
					services related to the account of the Division I. You will not be able to use the account to access
					our products and services, even if you choose the same mailbox.</span></li>
			<li><span style="font-size: 12pt;">3. Account deletion Once the account is cancelled, all content,
					information, data, records under the account registration, use of account-related products and
					services will be deleted or anonymized (except as otherwise provided by laws and regulations). You
					are voluntarily responsible for all consequences that may arise.</span></li>
		</ol>
		<p>&nbsp;</p>
		<p><span style="font-size: 12pt;">As used in this Privacy Policy, "LUCKYYX GAME", "we", "us", or "our" refer to
				LUCKYYX &nbsp;Limited and all of its subsidiaries. For detailed contact information, visit our Contact
				Us page below.</span></p>
		<p><span style="font-size: 12pt;">Our Privacy Policy applies only to the collection and processing of the Data
				that you may decide to provide to us in your use of: (i) our applications for mobile platforms or
				devices and our web applications accessible on third party social networking services ("SNS")
				(collectively, our mobile and web applications are referred to herein as ("LUCKYYX
				GAME&nbsp;Applications"), (ii) our game publisher networks, crowd sourcing service and platforms
				("Networks") provided in connection with LUCKYYX GAME&nbsp;Applications and Third-Party Mobile
				Applications (defined below), (iii) our portal for third-party publishers ("LUCKYYX GAME&nbsp;Developer
				Portal"), (iv) our web domains and subdomains, including member.hwxgame.com&nbsp;(collectively, our
				"Sites"), and web forums or messaging boards in LUCKYYX GAME&nbsp;Applications and our Sites
				(collectively, our "Forums"). Any and all of our LUCKYYX GAME&nbsp;Applications, Networks, LUCKYYX
				GAME&nbsp;Developer Portal, Sites and Forums are referred to herein as our "Services".</span></p>
		<p><span style="font-size: 12pt;">LUCKYYX GAME&nbsp;respects the privacy of online visitors and customers of our
				Services and complies with applicable laws for the protection of your privacy, including, without
				limitation, the European Union General Data Protection Regulation ("GDPR") and the Swiss and EU Privacy
				Shield Frameworks. We designed this Privacy Policy to provide you with an overview of the processes of
				the processing of personal information when using our Services, so that you can understand them. Please
				be sure to familiarize yourself with our privacy practices and let us know if you have any
				question.</span></p>
		<p><span style="font-size: 12pt;">To contact our Chief Information Security Officer who is also acting as the
				Data Protection Officer, please write to dragon@luckyyx.com.</span></p>
		<p><span style="font-size: 12pt;">We reserve the right to update this Privacy Policy at any time. If we modify
				this Privacy Policy in a material way, a notice may be posted in our Services and on the Sites along
				with the updated Privacy Policy. We will also update the "Last Updated Date" in the Privacy Policy. By
				continuing to access or use the Services after we have posted an updated Privacy Policy or have provided
				you with notice of a modification, you are indicating that you agree to be bound by the modified Privacy
				Policy. If the modified Privacy Policy is not acceptable to you, you should cease using the
				Services.</span></p>
		<p><span style="font-size: 12pt;">Please visit this page periodically to remain up-to-date as to any Privacy
				Policy changes. Take a moment now to read the following to learn about our information collection
				practices that may impact you as a registered user with access to our Services or a non-registered user
				of our Services (each a "LUCKYYX GAME&nbsp;User"). For information regarding the collection and use of
				Personal Information (defined below) from children under 14 years old, see the Section below, entitled
				"Our Policy Toward Children".</span></p>
		<p><span style="font-size: 12pt;">WHAT IS PERSONAL DATA AND NON-IDENTIFYING INFORMATION?</span></p>
		<p><span style="font-size: 12pt;">Wherever we talk about Personal Data below, we mean any information that can
				either itself identify you as an individual ("Personally Identifying Information") or that can be
				connected to you indirectly by linking it to Personally Identifying Information. In the course of using
				our Services, we may ask you to provide us with certain personally identifiable information that can be
				used to contact or identify you. Personally identifiable information may include, but is not limited to,
				your name, phone number, photo representation ("avatar"), email address and mailing address ("Personal
				Information").</span></p>
		<p><span style="font-size: 12pt;">We also collect non-personal information, which is data in a form that does
				not permit direct association with you or any specific individual ("Non-Identifying Information").
				Non-Identifying Information is aggregated and used to help improve our Services and Third Party Mobile
				Applications by providing a better way to understand the LUCKYYX GAME&nbsp;User experience with the
				level of interest in various portions of our Sites, specific LUCKYYX GAME&nbsp;Applications or specific
				Third-Party Mobile Applications. We may collect and process Non-Identifying Information for any purpose;
				details provided in this Privacy Policy about what Non-Identifying Information we collect currently, and
				how we use, transfer and disclose such Non-Identifying Information concern only how such information is
				collected and used today.</span></p>
		<p><span style="font-size: 12pt;">Either Personal Information or Non-Identifying Information may be used alone
				or in the aggregate with information collected from other LUCKYYX GAME&nbsp;Users. Our primary objective
				in collecting any Personal Information or Non-Identifying Information is to provide you with a superior
				and personally relevant user experience.</span></p>
		<p><span style="font-size: 12pt;">WHAT DATA WE COLLECT AND PROCESS</span></p>
		<p><span style="font-size: 12pt;">LUCKYYX GAME&nbsp;collects and processes Personal Data in the following
				occasions:</span></p>
		<p><span style="font-size: 12pt;">1.Where it is necessary for the performance of our agreement with you to
				provide a full-featured gaming service and deliver associated Content and Services;</span></p>
		<p><span style="font-size: 12pt;">1.Where it is necessary for the performance of our agreement with you to
				provide a full-featured gaming service and deliver associated Content and Services;</span></p>
		<p><span style="font-size: 12pt;">3.Where it is necessary for the purposes of the legitimate and legal interests
				of LUCKYYX GAME or a third party (e.g. the interests of our other customers), except where such
				interests are overridden by your prevailing legitimate interests and rights;</span></p>
		<p><span style="font-size: 12pt;">4.Where you have given consent to it.</span></p>
		<p><span style="font-size: 12pt;">Depending on the circumstances in which you use our services, we may collect
				and process different kinds of your Personal Information. The typical circumstances and specific types
				of information can be found in the table below:</span></p>
		<table>
			<tbody>
				<tr>
					<td>
						<p><span style="font-size: 12pt;">Circumstances of Collecting Personal Information</span></p>
					</td>
					<td>
						<p><span style="font-size: 12pt;">Categories of Personal Information We May Collect100</span>
						</p>
					</td>
				</tr>
				<tr>
					<td>
						<p><span style="font-size: 12pt;">Your Registration of LUCKYYX GAME</span></p>
					</td>
					<td>
						<p><span style="font-size: 12pt;">Email address; Information on mobile device type,</span></p>
					</td>
				</tr>
				<tr>
					<td>
						<p><span style="font-size: 12pt;">Users on our Services</span></p>
					</td>
					<td>
						<p><span style="font-size: 12pt;">mobile carrier, unique mobile device identifier ("Device
								ID");</span><br /><span style="font-size: 12pt;">Internet Protocol ("IP")
								address;</span><br /><span style="font-size: 12pt;">Geo-location.</span></p>
					</td>
				</tr>
				<tr>
					<td>
						<p><span style="font-size: 12pt;">Your Registration as a Third Party Publisher</span></p>
					</td>
					<td>
						<p><span style="font-size: 12pt;">Name;</span><br /><span style="font-size: 12pt;">Mailing
								address;</span><br /><span style="font-size: 12pt;">Email address;</span><br /><span
								style="font-size: 12pt;">Telephone number;</span><br /><span
								style="font-size: 12pt;">Bank account for vendor registration;</span><br /><span
								style="font-size: 12pt;">Taxation information for vendor registration.</span></p>
					</td>
				</tr>
				<tr>
					<td>
						<p><span style="font-size: 12pt;">Making a purchase on our Services</span></p>
					</td>
					<td>
						<p><span style="font-size: 12pt;">Payment data;</span><br /><span
								style="font-size: 12pt;">Typical credit card information (name, address, credit card
								number, expiration date and security code);</span><br /><span
								style="font-size: 12pt;">Data from your payment service provider.</span></p>
					</td>
				</tr>
				<tr>
					<td>
						<p><span style="font-size: 12pt;">Linking your LUCKYYX GAME account to an SNS</span></p>
					</td>
					<td>
						<p><span style="font-size: 12pt;">Username, alias and any other Personal Information you have
								independently submit, provided to and made accessible through the SNS, if you consent to
								LUCKYYX GAME&rsquo;s access.</span></p>
					</td>
				</tr>
				<tr>
					<td>
						<p><span style="font-size: 12pt;">Participating in our Promotion</span></p>
					</td>
					<td>
						<p><span style="font-size: 12pt;">Email address;</span><br /><span
								style="font-size: 12pt;">Mailing address.</span></p>
					</td>
				</tr>
				<tr>
					<td>
						<p><span style="font-size: 12pt;">Usage of our Services</span></p>
					</td>
					<td>
						<p><span style="font-size: 12pt;">Device type;</span><br /><span style="font-size: 12pt;">Mobile
								carrier;</span><br /><span style="font-size: 12pt;">IP address;</span><br /><span
								style="font-size: 12pt;">Platform version;</span><br /><span
								style="font-size: 12pt;">Geo-location;</span><br /><span
								style="font-size: 12pt;">Navigation;</span><br /><span
								style="font-size: 12pt;">Interaction and engagement information regarding LUCKYYX GAME
								Users.</span></p>
					</td>
				</tr>
			</tbody>
		</table>
		<p><span style="font-size: 12pt;">WHY DO WE COLLECT AND PROCESS DATA</span></p>
		<p><span style="font-size: 12pt;">Your Personal Information may be used, for instance:</span></p>
		<p><span style="font-size: 12pt;">1.To help us to develop, deliver, and improve our Services and
				advertising;</span></p>
		<p><span style="font-size: 12pt;">2.To recommend products of interest directly to you;</span></p>
		<p><span style="font-size: 12pt;">3.For market research purposes that support our efforts to deliver a more
				valuable service to our community of LUCKYYX GAME&nbsp;Users;</span></p>
		<p><span style="font-size: 12pt;">4.With your prior consent and your confirmation of the opt-in link sent to the
				e-mail address mentioned in your application form, we may occasionally email you with offers,
				promotions, and/or information of interest. To opt out of emails from us, please follow the unsubscribe
				instructions contained in the relevant emails or contact us at dragon@luckyyx.com</span></p>
		<p><span style="font-size: 12pt;">5.To allow us to keep you posted regarding our latest Service announcements,
				software updates, and upcoming events;</span></p>
		<p><span style="font-size: 12pt;">6.To send important notices, such as communications about your purchases and
				changes to our Terms of Use, this Privacy Policy, or other Service-specific policies. Because this
				information is important to your interactions with LUCKYYX GAME, you may not opt out of receiving these
				communications.</span></p>
		<p><span style="font-size: 12pt;">7.To audit and analyze data to improve our Services and customer
				communications.</span></p>
		<p><span style="font-size: 12pt;">DURATION OF STORAGE</span></p>
		<p><span style="font-size: 12pt;">Unless otherwise stated in the following sections, we will store the data only
				as long as necessary to achieve the purpose of processing or to fulfill our contractual or statutory
				obligations.</span></p>
		<p><span style="font-size: 12pt;">COOKIES &amp; OTHER TECHNOLOGIES</span></p>
		<p><span style="font-size: 12pt;">As is standard practice, we use "cookies" to help us study traffic patterns
				and understand the effectiveness of our marketing communications. A cookie is a small string of text
				that we send to your computer&rsquo;s or mobile device's browser. Other types of cookies exist, but the
				cookies we use in connection with our Services are only used to obtain browser-specific information. For
				example, we do not use cookies to retrieve data from your hard drive, pass on computer viruses, or
				capture your email address. Cookies we use can reveal, for instance, which pages are the most popular,
				how much time LUCKYYX GAME&nbsp;Users are spending there, and how they are interacting with the content
				on such pages.</span></p>
		<p><span style="font-size: 12pt;">You have the option to disable cookies by changing the options in your browser
				to stop accepting cookies or to prompt you before accepting a cookie from the pages you visit. If you do
				not accept cookies, however, you may not be able to view or use all portions of our Services due to
				limited functionality.</span></p>
		<p><span style="font-size: 12pt;">Some of our Services, including email messaging, use "click-through URLs"
				linked to other content on our Services. We track this click-through data to help us determine interest
				in topics, Services usability and other measures of LUCKYYX GAME&nbsp;User engagement.</span></p>
		<p><span style="font-size: 12pt;">We may also use "pixel tags," "web beacons," "clear GIFs" or similar means
				(individually or collectively "Pixel Tags") in connection with our Services and to collect usage,
				demographic and geographical location data. A Pixel Tag is an electronic image, often a single pixel
				that is ordinarily not visible to users and may be associated with cookies on a user&rsquo;s hard drive.
				Pixel Tags allow us to count users who have visited certain pages of the Sites, to deliver branded
				services and to help determine the effectiveness of promotional or advertising campaigns.</span></p>
		<p><span style="font-size: 12pt;">When you use our Services or Third-Party Mobile Applications, our servers
				automatically record information that your browser or the applicable Service or Third-Party Mobile
				Application sends ("Log Data"). This Log Data may include information such as your computer&rsquo;s or
				mobile device&rsquo;s IP address, browser type, language, Internet Service Provider (ISP), referring and
				exit pages, time spent, information searched for, time and date stamp, clickstream data and other
				statistics. We use this information to monitor, analyze and understand trends, for technical
				administration of Services and Third-Party Mobile Applications, and to gather demographic information
				about our LUCKYYX GAME&nbsp;User base as a whole. We, and Third Party Publishers may use this
				information for product and services improvements, and in marketing and advertising services.</span></p>
		<p><span style="font-size: 12pt;">BY CLICKING ON THE "SIGN UP" BUTTON, WHERE APPLICABLE, OR OTHERWISE BY
				ACCESSING OR USING OUR SERVICES YOU ARE CONSENTING TO THE USE OF COOKIES AND OTHER TRACKING TECHNOLOGIES
				ON YOUR DEVICE.</span></p>
		<p><span style="font-size: 12pt;">WHEN WE DISCLOSE YOUR INFORMATION WITH LUCKYYX GAME&nbsp;SERVICES</span></p>
		<p><span style="font-size: 12pt;">As a user with an account, you may create your own profile, connect with other
				LUCKYYX GAME&nbsp;Users of Services, send messages and transmit information through various channels.
				Please remember that any communications you have via our Services, depending on, for example, the
				functionality of any LUCKYYX GAME&nbsp;Application or Third-Party Mobile Application connected to our
				Services, may reveal your screen name and the content of your communications, making this information
				publicly available to other LUCKYYX GAME&nbsp;Users. LUCKYYX GAME&nbsp;is not responsible for the
				activities of other LUCKYYX GAME&nbsp;Users or other third parties with whom you choose to provide your
				Personal Information or otherwise interact.</span></p>
		<p><span style="font-size: 12pt;">With Third Parties for Industry Analysis</span></p>
		<p><span style="font-size: 12pt;">In addition to sharing aggregated Non-Identifying Information with Third Party
				Publishers, we may also share aggregated Non-Identifying Information with advertisers and ad networks
				("Advertising Entities") with whom we have strategic relationships. Unless you specifically opt in to
				share your Personal Information, the information that we share with these third parties will only be
				used in the form of Non-Identifying Information to support user trend analyses and demographic
				profiling. Some Third Party Publishers and Advertising Entities also act as Service Providers (defined
				below) to us, so in those cases we will share your information as described below.</span></p>
		<p><span style="font-size: 12pt;">With Preferred Partners</span></p>
		<p><span style="font-size: 12pt;">We may share your username, email address, MAC address and Device ID
				(collectively, "Specific Shared Data") with certain of our Third Party Publishers and other business
				partners ("Preferred Partners") for those parties to assist us with providing you with the aspect of the
				Services for which you provided such Specific Shared Data to us, and to use such Specific Shared Data to
				provide you with information and marketing materials about Third Party Mobile Applications and other
				products and services in order, for example, to further enhance your use of our Services and to augment
				your gaming and social networking experience generally. In addition, in the event of a user inquiry
				concerning Third Party Publishers or Third Party Applications, we may send Specific Shared Data as well
				as the inquiry to a Preferred Partner to address the inquiry.</span></p>
		<p><span style="font-size: 12pt;">We only share such information with Preferred Partners pursuant to an
				agreement by which the Preferred Partner is under obligations not to disclose or use it for any other
				purpose. You may contact us by any of the means provided in the "Contacting Us" section below to request
				not to have such information provided to Preferred Partners, understanding, however, that if such
				information is not shared with Preferred Partners it may affect your ability to use or access portions
				of the Services.</span></p>
		<p><span style="font-size: 12pt;">Some Preferred Partners also act as Service Providers (defined below) to us,
				and in those cases we may also share Personal Information and Non-Identifying Information as described
				below.</span></p>
		<p><span style="font-size: 12pt;">With Third Party Social Networking Services (SNSs)</span></p>
		<p><span style="font-size: 12pt;">As a user with an account, you may link your LUCKYYX GAME&nbsp;account
				information with certain SNSs where other LUCKYYX GAME&nbsp;Users have existing SNS accounts. In these
				instances, with your permission and on your behalf, we will share your email address and screen name or
				alias with the applicable SNS. Through use of such services&rsquo; application programming interfaces
				(APIs) we can receive certain information (which may include your Personal Information) in accordance
				with the privacy settings you have set in your SNS account, if any.</span></p>
		<p><span style="font-size: 12pt;">Other than what we may share with the SNS in connection with your linking of
				accounts, the personal information an SNS has about you is obtained by the SNS independent of our
				Services. Other services follow different rules regarding the use or disclosure of the personal
				information you submit to them. We encourage you to read the privacy policies or statements of the other
				services you use.</span></p>
		<p><span style="font-size: 12pt;">With our Service Providers</span></p>
		<p><span style="font-size: 12pt;">Disclosure of your Personal Information and Non-Identifying Information may
				also occur where we engage or employ service providers, vendors or other third party entities to
				facilitate provision of our Services (each a "Service Provider") (e.g., without limitation, improvement
				of our Services&rsquo; features, user account authentication, promotion and marketing, administration,
				analytics, virtual currency transactions, crowd-sourcing, cloud storage and other related services), to
				provide the Services on our behalf, or to assist us in analyzing how our Services are being used. Our
				Service Providers may have access to your Personal Information only to perform these tasks on our behalf
				and are obligated not to disclose or use it for any other purpose.</span></p>
		<p><span style="font-size: 12pt;">Under Special Circumstances</span></p>
		<p><span style="font-size: 12pt;">At times, we may disclose information about you to law enforcement officials
				or private parties as we, in our sole discretion, believe necessary or appropriate to respond to claims
				and legal process (including but not limited to subpoenas), to protect the property and rights of
				LUCKYYX GAME&nbsp;or a third party, to protect the safety of the public or any person or to prevent or
				stop activity we may consider to be or to pose a risk of being, any illegal, unethical or legally
				actionable activity.</span></p>
		<p><span style="font-size: 12pt;">Under another special set of circumstances, for example, in connection with a
				merger, acquisition, reorganization or sale of assets, or in the event of bankruptcy, we may sell,
				transfer or otherwise share some or all of LUCKYYX GAME&nbsp;assets, including your Personal
				Information.</span></p>
		<p><span style="font-size: 12pt;">OUR POLICY TOWARD CHILDREN</span></p>
		<p><span style="font-size: 12pt;">Our Services are not intended for children under the age of 14 ("children")
				and we do not knowingly collect any Personal Information from children. If we discover that we have
				inadvertently collected Personal Information from children, we will take all reasonable measures to
				erase such information from our systems and records as soon as possible.</span></p>
		<p><span style="font-size: 12pt;">USE AS A NON-REGISTERED USER</span></p>
		<p><span style="font-size: 12pt;">In certain LUCKYYX GAME&nbsp;Applications, an LUCKYYX GAME&nbsp;User may
				participate as a non-registered LUCKYYX GAME&nbsp;User through optional registration. This allows an
				LUCKYYX GAME&nbsp;User to play the game in a limited capacity. LUCKYYX GAME&nbsp;does not collect any
				Personal Information or Non-Identifying information, other than Device ID, for non-registered users.
				LUCKYYX GAME&nbsp;cannot and does not ensure the preservation of game data that is associated with any
				non-registered account.</span></p>
		<p><span style="font-size: 12pt;">LOCATION-BASED SERVICES</span></p>
		<p><span style="font-size: 12pt;">For location-based Services, we may collect, use, and share precise location
				data, including the real-time geographic location of your computer or mobile device. Unless you
				explicitly opt-in to permit the use and sharing of your Personal Information regarding your geographic
				location, your location data will only be collected and used anonymously in a form that does not
				personally identify you. When you opt in to Third Party Mobile Application providers&rsquo; location
				services, we will share your geographic location with such Third Party Mobile Application providers in
				connection with their location services. Please note that some location-based services may require your
				Personal Information for the feature to work as intended.</span></p>
		<p><span style="font-size: 12pt;">INVITE-A-FRIEND</span></p>
		<p><span style="font-size: 12pt;">If you choose to use our referral services to tell a friend about our
				Services, we will ask you for your friend&rsquo;s name and email address. We will automatically send
				your friend a one-time email inviting him or her to use an aspect of our Services. LUCKYYX
				GAME&nbsp;hashes these email addresses after using them for the sole purpose of sending this one-time
				email.</span></p>
		<p><span style="font-size: 12pt;">LUCKYYXILING VIA A LUCKYYX GAME&nbsp;APPLICATION</span></p>
		<p><span style="font-size: 12pt;">LUCKYYX GAME&nbsp;Users may send pre-formatted messages through use of their
				personal email account connected to their mobile device to, for example, challenge their friends to beat
				their high score in an LUCKYYX GAME&nbsp;Application where this functionality is available. LUCKYYX
				GAME&nbsp;may store the email address of the friend that you choose to email via our Services, but would
				only do so for social purposes such as generating friend recommendations (e.g., in connection with
				"people you may know" functionality). The message you initiate will be sent through your personal email
				account to the email addresses you choose.</span></p>
		<p><span style="font-size: 12pt;">HOW WE PROTECT YOUR PERSONAL INFORMATION</span></p>
		<p><span style="font-size: 12pt;">LUCKYYX GAME&nbsp;takes your privacy very seriously and employs
				administrative, physical and electronic measures to safeguard your information from identity theft and
				unauthorized access. We do not and will not, at any time, request your credit card information, your
				account ID, login password or national identification numbers in a non-secure or unsolicited
				communication (e.g. via e-mail, telephone, mobile device).</span></p>
		<p><span style="font-size: 12pt;">We will make any legally required disclosures of any breach of the security,
				confidentiality, or integrity of your unencrypted electronically stored "personal data" (as defined in
				applicable state statutes on security breach notification) to you via email or conspicuous posting on
				the Sites in the most expedient time possible and without unreasonable delay, insofar as consistent with
				(i) the legitimate needs of law enforcement or (ii) any measures necessary to determine the scope of the
				breach and restore the reasonable integrity of the data system.</span></p>
		<p><span style="font-size: 12pt;">YOUR RIGHTS</span></p>
		<p><span style="font-size: 12pt;">The data protection laws of the European Economic Area and other territories
				grant their citizens certain rights in relation to their Personal Data. While other jurisdictions may
				provide fewer statutory rights to their citizens.</span></p>
		<p><span style="font-size: 12pt;">As a user of an account, you may update or delete the Personal Information in
				your profile by logging into your account. You may also email us at LUCKYYXboss@hwxgame.com&nbsp;to
				request that we delete your Personal Information from our database. We will use commercially reasonable
				efforts to honor your request. We may retain an archived copy of your records as required by law or for
				legitimate business purposes. Specific Shared Data cannot be retrieved from Preferred Partners after its
				disclosure.</span></p>
		<p><span style="font-size: 12pt;">Where you share information with other users through the communication
				channels of our Services, you generally should not expect to have any ability to modify or remove such
				communications. Nor should you expect us to modify or delete your comments upon your request.</span></p>
		<p><span style="font-size: 12pt;">If you participate in a Promotion hosted by us (where you may or may not
				disclose the information requested), you have the option to opt out at any time from such participation
				and the receipt of any related communications. Please follow the unsubscribe instructions provided in
				the relevant communications.</span></p>
		<p><span style="font-size: 12pt;">If your friend received an invitation from LUCKYYX GAME&nbsp;per your referral
				to try the Services, your friend may request that the name and email address used in the invitation be
				removed from LUCKYYX GAME&rsquo;s records. We store this information for the sole purposes of measuring
				the effectiveness of our referral program and sending the email you initiated, but your friend can
				request to have it removed from our database by emailing us at @luckyyx.com..</span></p>
		<p><span style="font-size: 12pt;">As a resident of the European Economic Area you have the following rights in
				relation to your Personal Data:</span></p>
		<p><span style="font-size: 12pt;">1.Right of Access.</span></p>
		<p><span style="font-size: 12pt;">You have the right to access your Personal Data that we hold about you, i.e.
				the right to require free of charge (i) information whether your Personal Data is retained, (ii) access
				to and/or (iii) duplicates of the Personal Data retained. You can use the right to access to your
				Personal Data. If the request affects the rights and freedoms of others or is manifestly unfounded or
				excessive, we reserve the right to refuse to act on the request.</span></p>
		<p><span style="font-size: 12pt;">2.Right to Rectification.</span></p>
		<p><span style="font-size: 12pt;">If your Personal Data is inaccurate or incomplete, you can change the
				information in your profile by logging into your account, for those non-editable Data in your profile,
				you may email us at dragon@luckyyx.com&nbsp;to make a request. If we process your Personal Data, we
				shall endeavor to ensure by implementing suitable measures that your Personal Data is accurate and
				up-to-date for the purposes for which it was collected.</span></p>
		<p><span style="font-size: 12pt;">3.Right to Erasure.</span></p>
		<p><span style="font-size: 12pt;">You have the right to obtain deletion by us of Personal Data concerning you by
				email us at dragon@luckyyx.com &nbsp;to request that we delete your LUCKYYX&nbsp;Account.As a result of
				deleting your LUCKYYX&nbsp;Account, you will lose access to our Services you are using the
				LUCKYYX&nbsp;Account for.</span></p>
		<p><span style="font-size: 12pt;">We allow you to restore your LUCKYYX&nbsp;Account during a grace period of 30
				(thirty) days from the moment you request deletion of your LUCKYYX&nbsp;Account. This functionality
				allows you not to lose your account by mistake, because of your loss of your account credentials or due
				to hacking. During the suspension period, we will be able to finalize financial and other activities
				that you may have initiated before sending the LUCKYYX&nbsp;Account deletion request. After the grace
				period, Personal Data associated with your account will be deleted from our database. In some cases,
				considering the complexity and number of the requests, the period for Personal Data erasure may be
				extended, but for no longer than two further months.</span></p>
		<p><span style="font-size: 12pt;">4.Right to Object.</span></p>
		<p><span style="font-size: 12pt;">When our processing of your Personal Data is based on legitimate interests
				according to Article 6(1)(f) of the GDPR / section 2.c) of this Privacy Policy, you have the right to
				object to these processing. If you object we will no longer process your Personal Data unless there are
				compelling and prevailing legitimate grounds for the processing as described in Article 21 of the GDPR;
				in particular if the data is necessary for the establishment, exercise or defense of legal
				claims.</span></p>
		<p><span style="font-size: 12pt;">5.You also have the right to lodge a complaint at a supervisory
				authority.</span></p>
		<p><span style="font-size: 12pt;">LINKS TO OTHER WEBSITES AND SERVICES</span></p>
		<p><span style="font-size: 12pt;">Our Services may contain links to other websites and online services or offers
				from third parties. For example, our Services may include offers from third party advertisers or the
				ability to engage in transactions with such entities. If an LUCKYYX GAME&nbsp;User with an account
				chooses to participate in offer-linked information requests or "clicks on" an advertisement or another
				third party link, such LUCKYYX GAME&nbsp;User may be directed to that third party&rsquo;s website or
				service and/or be prompted to provide Personal Information in connection with such activity.</span></p>
		<p><span style="font-size: 12pt;">The fact that we link to a third party website or service is not an
				endorsement or representation of our affiliation with that third party, nor is it an endorsement of such
				third party&rsquo;s privacy or information security policies or practices or their compliance with laws.
				We do not exercise control over third party websites or services. These other websites or services may
				place their own cookies or other files on your computer or mobile devices, collect data or solicit
				personal information from you. Other websites and services follow different rules regarding the use or
				disclosure of the personal information you submit to them. We encourage you to read the privacy policies
				or statements of the other websites and services you use and the terms of the offers in which you
				participate. You agree that LUCKYYX GAME&nbsp;is not responsible for, nor will it be liable to you or
				any third party for, your interaction with such third parties or the information requests initiated by
				such third parties or the subsequent use, treatment or dissemination of the information you voluntarily
				choose to provide to them.</span></p>
		<p><span style="font-size: 12pt;">ADDITIONAL INFORMATION FOR USERS FROM THE EUROPEAN ECONOMIC AREA</span></p>
		<p><span style="font-size: 12pt;">Information that you provide may be transferred or accessed by entities around
				the world as described in this Privacy Policy. If you are located in European Economic Area, you
				understand that we may transfer Personal Information to and process it in the United States. Your
				consent to this Privacy Policy followed by your submission of Personal Information represents your
				agreement to that transfer.</span></p>
		<p><span style="font-size: 12pt;">LUCKYYX GAME&nbsp;abides by the EU-U.S. Privacy Shield Framework and the
				Swiss-U.S. Privacy Shield Framework as set forth by the U.S. Department of Commerce regarding the
				collection, use, and retention of personal information transferred from the European Union and
				Switzerland to the United States. If there is any conflict between the terms in this privacy policy and
				the Privacy Shield Principles, the Privacy Shield Principles shall govern. To learn more about the
				Privacy Shield program, and to view our certification, please visit http://www.privacyshield.gov.</span>
		</p>
		<p><span style="font-size: 12pt;">Individuals who wish to file a complaint or who take issue with our privacy
				policies should first contact us here. If you are sending us a privacy-related complaint, please provide
				it in English because this will help expedite the process. We will investigate and attempt to resolve
				complaints regarding use and disclosure of personal information in accordance with the principles
				contained in this Privacy Policy. For complaints that cannot be resolved between LUCKYYX GAME&nbsp;and a
				complainant, we commit to cooperate with data protection authorities located in the European Union, the
				Swiss Federal Data Protection and Information Commissioner, or their authorized representatives to
				resolve such disputes.</span></p>
		<p><span style="font-size: 12pt;">YOUR CALIFORNIA PRIVACY RIGHTS</span></p>
		<p><span style="font-size: 12pt;">California Civil Code Section 1798.83 permits customers of LUCKYYX
				GAME&nbsp;who are California residents to request certain information regarding our disclosure of
				personal information to third parties for their direct marketing purposes. If you are a California
				resident and have provided LUCKYYX GAME&nbsp;with personal information within the last year, you may
				make such a request by emailing us at the following email address with the email&rsquo;s subject titled
				as "California Privacy Rights": dragon@luckyyx.com.</span></p>
		<p><span style="font-size: 12pt;">Within thirty (30) calendar days of receiving such a request, we will provide
				a list of the categories of personal information disclosed to third parties for such third
				parties&rsquo; direct marketing purposes during the immediately preceding calendar year, along with the
				names and addresses of these third parties. A request may be made no more than once per calendar year
				and we are not required to respond to requests made by means other than through the email address
				above.</span></p>
		<p><span style="font-size: 12pt;">To the extent that any of our mobile applications of the Services collects
				personally identifiable information, that is done only as strictly necessary to enable us to provide
				those Services (see "When We Collect Information" and "Cookies &amp; Other Technologies", above), and
				this cannot be disabled by "do not track" or other mechanisms available on your mobile Device&rsquo;s
				browser.</span></p>
	</div>
</template>
<script>
	export default {
		name: 'PrivacyEN'
	}
</script>
<style scoped>
	.text_privacy p {
		width: 100%;
		height: 100%;
		text-indent: 4ch;
	}

	.text_privacy {
		padding: 20px;
	}
</style>